import React from 'react';

/* Reusable component for floating view */
const FloatingView = ({ children, className = '', ...props }) => (
  <span
    className={`floating-view-badge fw-bold ${className}`}
    {...props}
  >
    {children}
  </span>
);

export default FloatingView; 